/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BomDto } from '../models/bom-dto';
import { BomDtoDlmBaseResponse } from '../models/bom-dto-dlm-base-response';
import { BomDtoListDlmBaseResponse } from '../models/bom-dto-list-dlm-base-response';
import { BomDtoPagedResponseDlmBaseResponse } from '../models/bom-dto-paged-response-dlm-base-response';
import { BomItemDtoListDlmBaseResponse } from '../models/bom-item-dto-list-dlm-base-response';
import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { OrderDirection } from '../models/order-direction';
import { PropertyFilter } from '../models/property-filter';

@Injectable({
  providedIn: 'root',
})
export class BomService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiBomBomsGet
   */
  static readonly ApiBomBomsGetPath = '/api/Bom/boms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomBomsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomsGet$Plain$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<BomDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomBomsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomBomsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomsGet$Plain(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<BomDtoListDlmBaseResponse> {

    return this.apiBomBomsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoListDlmBaseResponse>) => r.body as BomDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomBomsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomsGet$Json$Response(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<StrictHttpResponse<BomDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomBomsGetPath, 'get');
    if (params) {
      rb.query('searchTerm', params.searchTerm, {});
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomBomsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomsGet$Json(params?: {
    searchTerm?: string;
    archived?: boolean;
  }): Observable<BomDtoListDlmBaseResponse> {

    return this.apiBomBomsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoListDlmBaseResponse>) => r.body as BomDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomPaginatedBomsGet
   */
  static readonly ApiBomPaginatedBomsGetPath = '/api/Bom/paginated-boms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomPaginatedBomsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomPaginatedBomsGet$Plain$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<BomDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomPaginatedBomsGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomPaginatedBomsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomPaginatedBomsGet$Plain(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<BomDtoPagedResponseDlmBaseResponse> {

    return this.apiBomPaginatedBomsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoPagedResponseDlmBaseResponse>) => r.body as BomDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomPaginatedBomsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomPaginatedBomsGet$Json$Response(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<StrictHttpResponse<BomDtoPagedResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomPaginatedBomsGetPath, 'get');
    if (params) {
      rb.query('PageIndex', params.PageIndex, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('GetAll', params.GetAll, {});
      rb.query('Archived', params.Archived, {});
      rb.query('SearchTerm', params.SearchTerm, {});
      rb.query('PropertyFilters', params.PropertyFilters, {});
      rb.query('OrderProperty', params.OrderProperty, {});
      rb.query('Order', params.Order, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoPagedResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomPaginatedBomsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomPaginatedBomsGet$Json(params?: {
    PageIndex?: number;
    PageSize?: number;
    GetAll?: boolean;
    Archived?: boolean;
    SearchTerm?: string;
    PropertyFilters?: Array<PropertyFilter>;
    OrderProperty?: string;

    /**
     * 0 &#x3D; Ascending
     * 
     * 1 &#x3D; Descending
     */
    Order?: OrderDirection;
  }): Observable<BomDtoPagedResponseDlmBaseResponse> {

    return this.apiBomPaginatedBomsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoPagedResponseDlmBaseResponse>) => r.body as BomDtoPagedResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomBomGet
   */
  static readonly ApiBomBomGetPath = '/api/Bom/bom';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomBomGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomGet$Plain$Response(params?: {
    bomId?: number;
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomBomGetPath, 'get');
    if (params) {
      rb.query('bomId', params.bomId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomBomGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomGet$Plain(params?: {
    bomId?: number;
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomBomGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomBomGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomGet$Json$Response(params?: {
    bomId?: number;
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomBomGetPath, 'get');
    if (params) {
      rb.query('bomId', params.bomId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomBomGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomGet$Json(params?: {
    bomId?: number;
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomBomGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomBomByProductIdGet
   */
  static readonly ApiBomBomByProductIdGetPath = '/api/Bom/bom-by-product-id';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomBomByProductIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomByProductIdGet$Plain$Response(params?: {
    productId?: number;
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomBomByProductIdGetPath, 'get');
    if (params) {
      rb.query('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomBomByProductIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomByProductIdGet$Plain(params?: {
    productId?: number;
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomBomByProductIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomBomByProductIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomByProductIdGet$Json$Response(params?: {
    productId?: number;
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomBomByProductIdGetPath, 'get');
    if (params) {
      rb.query('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomBomByProductIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomBomByProductIdGet$Json(params?: {
    productId?: number;
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomBomByProductIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomAddBomPost
   */
  static readonly ApiBomAddBomPostPath = '/api/Bom/add-bom';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomAddBomPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomAddBomPost$Plain$Response(params?: {
    body?: BomDto
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomAddBomPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomAddBomPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomAddBomPost$Plain(params?: {
    body?: BomDto
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomAddBomPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomAddBomPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomAddBomPost$Json$Response(params?: {
    body?: BomDto
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomAddBomPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomAddBomPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomAddBomPost$Json(params?: {
    body?: BomDto
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomAddBomPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomUpdateBomPut
   */
  static readonly ApiBomUpdateBomPutPath = '/api/Bom/update-bom';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomUpdateBomPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomUpdateBomPut$Plain$Response(params?: {
    body?: BomDto
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomUpdateBomPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomUpdateBomPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomUpdateBomPut$Plain(params?: {
    body?: BomDto
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomUpdateBomPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomUpdateBomPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomUpdateBomPut$Json$Response(params?: {
    body?: BomDto
  }): Observable<StrictHttpResponse<BomDtoDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomUpdateBomPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomDtoDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomUpdateBomPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiBomUpdateBomPut$Json(params?: {
    body?: BomDto
  }): Observable<BomDtoDlmBaseResponse> {

    return this.apiBomUpdateBomPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BomDtoDlmBaseResponse>) => r.body as BomDtoDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomArchivePost
   */
  static readonly ApiBomArchivePostPath = '/api/Bom/archive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomArchivePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomArchivePost$Plain$Response(params?: {
    bomId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomArchivePostPath, 'post');
    if (params) {
      rb.query('bomId', params.bomId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomArchivePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomArchivePost$Plain(params?: {
    bomId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiBomArchivePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomArchivePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomArchivePost$Json$Response(params?: {
    bomId?: number;
    archive?: boolean;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomArchivePostPath, 'post');
    if (params) {
      rb.query('bomId', params.bomId, {});
      rb.query('archive', params.archive, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomArchivePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomArchivePost$Json(params?: {
    bomId?: number;
    archive?: boolean;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiBomArchivePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomImportBomCsvPost
   */
  static readonly ApiBomImportBomCsvPostPath = '/api/Bom/import-bom-csv';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomImportBomCsvPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiBomImportBomCsvPost$Plain$Response(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<BomItemDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomImportBomCsvPostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomItemDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomImportBomCsvPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiBomImportBomCsvPost$Plain(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<BomItemDtoListDlmBaseResponse> {

    return this.apiBomImportBomCsvPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BomItemDtoListDlmBaseResponse>) => r.body as BomItemDtoListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomImportBomCsvPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiBomImportBomCsvPost$Json$Response(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<BomItemDtoListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomImportBomCsvPostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BomItemDtoListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomImportBomCsvPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiBomImportBomCsvPost$Json(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<BomItemDtoListDlmBaseResponse> {

    return this.apiBomImportBomCsvPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BomItemDtoListDlmBaseResponse>) => r.body as BomItemDtoListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiBomDownloadDrawingsZipBomIdGet
   */
  static readonly ApiBomDownloadDrawingsZipBomIdGetPath = '/api/Bom/download-drawings-zip/{bomId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiBomDownloadDrawingsZipBomIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomDownloadDrawingsZipBomIdGet$Response(params: {
    bomId: number;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, BomService.ApiBomDownloadDrawingsZipBomIdGetPath, 'get');
    if (params) {
      rb.path('bomId', params.bomId, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/zip'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiBomDownloadDrawingsZipBomIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiBomDownloadDrawingsZipBomIdGet(params: {
    bomId: number;
  }): Observable<string> {

    return this.apiBomDownloadDrawingsZipBomIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
